var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 3.5124C24.9922 3.89549 24.8453 4.26267 24.5868 4.54545L12.8099 16.3223L10.5372 18.595C10.2544 18.8536 9.88723 19.0005 9.50413 19.0083C9.12104 19.0005 8.75386 18.8536 8.47108 18.595L6.19835 16.3223L0.413223 10.5372C0.154664 10.2544 0.00779223 9.88723 0 9.50413C0.00779223 9.12104 0.154664 8.75386 0.413223 8.47108L2.68595 6.19835C2.96874 5.93979 3.33592 5.79292 3.71901 5.78512C4.1021 5.79292 4.46928 5.93979 4.75207 6.19835L9.50413 10.9504L20.0413 0.413223C20.3241 0.154664 20.6913 0.00779223 21.0744 0C21.4575 0.00779223 21.8247 0.154664 22.1074 0.413223L24.3802 2.68595C24.7934 2.89256 25 3.09917 25 3.5124Z",
    fill: "#2F6FA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ab2e4ed7d7798f7f6e0a76d0c5752eff.svg";
export { ForwardRef as ReactComponent };